// useDimensionsStore.ts
import { SIDEBARDEFAULTMARGIN, SIDEBARFULLWIDTH, SIDEBARSMALLWIDTH } from '@/components/customUtils/AppConstants'
import { create } from 'zustand'

type SideBarState = {
    sideBarWidth: number
    sideBarMarginRight?: number
    isOpen: boolean
    setIsOpen: (isOpen: boolean) => void
    setSideBarMarginRight: (margin: number) => void
}

export const sideBarStore = create<SideBarState>((set) => {
    return {
        sideBarWidth: SIDEBARFULLWIDTH,
        sideBarMarginRight: SIDEBARDEFAULTMARGIN,
        isOpen: true,
        setIsOpen: (isOpen) => set({ isOpen, sideBarWidth: isOpen ? SIDEBARFULLWIDTH : SIDEBARSMALLWIDTH }),
        setSideBarMarginRight: (margin) => set({ sideBarMarginRight: margin ?? SIDEBARDEFAULTMARGIN }),
    }
})
